import axios from 'axios';

// W produkcji frontend jest serwowany jako statyczne pliki (public_html),
// a backend Node.js działa osobno na porcie 3001.
// Jeśli otwierasz aplikację przez Node.js bezpośrednio (localhost:3001), użyj '/api'.
// Jeśli frontend jest na Apache/Nginx (bazawiedzy.wheeltrade.pl), użyj pełnego adresu backendu.
export const BACKEND_URL = process.env.REACT_APP_API_URL || '';
const api = axios.create({ baseURL: BACKEND_URL + '/api' });
api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  // Apache blokuje PUT/DELETE — konwertuj na POST z nagłówkiem X-HTTP-Method-Override
  if (cfg.method === 'put' || cfg.method === 'delete') {
    cfg.headers['X-HTTP-Method-Override'] = cfg.method.toUpperCase();
    cfg.method = 'post';
  }
  return cfg;
});
api.interceptors.response.use(r => r, err => {
  if (err.response?.status === 401) {
    localStorage.removeItem('token');
    window.location.href = '/login';
  }
  return Promise.reject(err);
});
export default api;
